import React, { useEffect } from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Menu from "@mui/material/Menu";
import Avatar from "@mui/material/Avatar";
import Tooltip from "@mui/material/Tooltip";
import MenuItem from "@mui/material/MenuItem";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../../context/auth";
import { useSelector } from "react-redux";
import profileDummy from "../../assets/images/profileIcon.svg";
import mainLogo from "../../assets/images2/logo.png";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

function ResponsiveAppBar() {
  const [anchorElUser, setAnchorElUser] = React.useState(null);
  const [activeMenu, setMenu] = React.useState(null);
  const [roleName, setRoleName] = React.useState(null);
  const [userName, setUserName] = React.useState(null);
  const [dp, setDP] = React.useState(null);
  const { logout } = useAuth();

  const { pathname } = useLocation();
  const location = window.location.href;
  const homePageUrl = location.endsWith(pathname)
    ? location.slice(0, -pathname.length)
    : location;

  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  const handleClickMenu = (value) => {
    setAnchorElUser(null);
    setMenu(value);
  };

  const navigate = useNavigate();

  const Index = () => {
    navigate(`/admin/dashboard`);
  };

  let settings = ["Logout"];

  if (roleName === "user") {
    settings = ["Profile", "Account", "Favourites", "Logout"];
  }

  useEffect(() => {
    if (activeMenu === "Logout") {
      logout(true);
      navigate("/admin/authenticate");
    }
  }, [logout, activeMenu]);

  return (
    <React.Fragment>
      <AppBar position="static" className="header_main">
        <Box component="div" className="app_bar_main site-container">
          <Toolbar disableGutters>
            <Box
              sx={{ display: { xs: "flex", md: "none" } }}
              className="mobile_drawer"
            ></Box>

            <Box
              component="a"
              href={homePageUrl}
              className="main_logo"
              onClick={Index}
            >
              <img src={mainLogo} alt="" />
            </Box>

            <Box sx={{ flexGrow: 0 }} className="header_user">
              <KeyboardArrowDownIcon onClick={handleOpenUserMenu} />
              <Typography variant="span" component="span" className="">
                Admin
              </Typography>
              <Tooltip title="Open settings">
                <Avatar
                  alt={userName}
                  src={dp ? dp : profileDummy}
                  onClick={handleOpenUserMenu}
                  sx={{
                    width: 30,
                    height: 30,
                    backgroundColor: "#fff",
                    float: "right",
                  }}
                />
              </Tooltip>
              <Menu
                sx={{ mt: "45px" }}
                id="menu-appbar"
                anchorEl={anchorElUser}
                anchorOrigin={{
                  vertical: "top",
                  horizontal: "right",
                }}
                keepMounted
                transformOrigin={{
                  vertical: "top",
                  horizontal: "right",
                }}
                open={Boolean(anchorElUser)}
                onClose={handleCloseUserMenu}
              >
                {settings.map((setting) => (
                  <MenuItem
                    key={setting}
                    onClick={() => handleClickMenu(setting)}
                  >
                    <Typography textalign="center">{setting}</Typography>
                  </MenuItem>
                ))}
              </Menu>
            </Box>
          </Toolbar>
        </Box>
      </AppBar>
    </React.Fragment>
  );
}
export default ResponsiveAppBar;
